import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './@auth/auth.guard';
import { LogoutComponent } from './pages/logout/logout.component';
import { SwitchComponent } from './pages/switch/switch.component';
import { RaygunErrorHandler } from './app.raygun.setup';

const logger = new RaygunErrorHandler();

const routes: Routes = [
  {
    path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/pages.module')
        .then((m) => m.PagesModule)
        .catch((error) => {
          logger.handleError(error, {
            caughtClass: 'AppRoutingModule',
            caughtMethod: 'loadChildren',
            caughtCall: 'pages.module',
            errorMessage: error.message,
          });
        }),
  },
  {
    path: 'pop-out',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pop-out/pop-out.module')
        .then((m) => m.PopOutModule)
        .catch((error) => {
          logger.handleError(error, {
            caughtClass: 'AppRoutingModule',
            caughtMethod: 'loadChildren',
            caughtCall: 'pop-out.module',
            errorMessage: error.message,
          });
        }),
  },
  { path: 'logout', component: LogoutComponent },
  { path: 'switch', component: SwitchComponent },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
